<div class="wrapper">
    <svg width="2em" height="2em" id="left-arrow" (click)="onPreviousClick()" viewBox="0 0 16 16" fill="grey" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-7.646 2.646a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L6.207 7.5H11a.5.5 0 0 1 0 1H6.207l2.147 2.146z"/>
    </svg>

    <ng-container *ngFor="let url of slides; let i = index">
        <img
            *ngIf="i === currentSlide"
            mat-card-image 
            [src]="url"
            class="card-image"
            [alt]="name"
            @sliderAnimation
        />
    </ng-container>
    
    <svg width="2em" height="2em" id="right-arrow" (click)="onNextClick()" viewBox="0 0 16 16" fill="grey" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-8.354 2.646a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L9.793 7.5H5a.5.5 0 0 0 0 1h4.793l-2.147 2.146z"/>
    </svg>
</div>